import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'grape' | 'blush';
};
export const CHECKOUT_URL = 'https://the-freelance-proposal-machine.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'blush'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[65px] px-8 py-4 text-[17px]' : 'min-h-[58px] px-6 py-3.5 text-base';
  const skin = variant === 'blush' ? 'bg-blush text-white shadow-[0_0_0_1px_rgba(46,197,255,0.5),0_10px_36px_-8px_rgba(0,112,255,0.75)] hover:bg-blush-deep hover:shadow-[0_0_0_1px_rgba(46,197,255,0.8),0_16px_46px_-8px_rgba(0,112,255,0.9)] focus-visible:ring-plum' : 'bg-plum text-white shadow-[0_0_0_1px_rgba(46,197,255,0.6),0_10px_36px_-10px_rgba(0,112,255,0.7)] hover:bg-plum-soft focus-visible:ring-grape';
  return <a href={href} className={cn('group inline-flex w-full max-w-[360px] items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow] duration-200 ease-out hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} data-id="element-33" data-mp="199y687sbvn0k">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-34" data-mp="1s793xnyba8dw" />
    </a>;
}